import axios from '~/lib/axios';

import { objectPropsToSnakeCase } from '~/lib/utils/api';

export default class Api {
  searchCompanyProfiles(companyName) {
    return axios.get(
      this.kvkProfilesUrl(), {
        params: objectPropsToSnakeCase({ companyName })
      }
    );
  }

  getCompanyData(kvkNumber) {
    return axios.get(
      this.kvkProfileUrl(kvkNumber)
    );
  }

  kvkProfilesUrl() {
    return '/kvk_profiles';
  }

  kvkProfileUrl(kvkNumber) {
    return `/kvk_profiles/${kvkNumber}`;
  }
}
